import React, { useEffect, useMemo, useState } from 'react';
import { Modal, Text, Button } from 'v3/components';
import TextArea from 'v3/components/TextArea';
import { styles } from './styles';

export default function CancelChecklistModal({
  open = false,
  onClose,
  onConfirm,
  loading = false,
  checklistTitle = '',
  checklistId = null,
  errorMessage = '',
}) {
  const [reason, setReason] = useState('');
  const [touched, setTouched] = useState(false);

  useEffect(() => {
    if (!open) return;
    setReason('');
    setTouched(false);
  }, [open]);

  const trimmed = useMemo(() => reason.trim(), [reason]);
  const isValid = trimmed.length >= 30;
  const validationError =
    touched && !isValid ? 'Informe um motivo com no minimo 30 caracteres.' : '';
  const error = errorMessage || validationError;
  const displayTitle = useMemo(() => {
    const normalizedTitle = String(checklistTitle || 'Checklist').trim();
    if (!checklistId) return normalizedTitle;
    if (normalizedTitle.startsWith(`#${checklistId}`)) return normalizedTitle;
    return `#${checklistId} ${normalizedTitle}`;
  }, [checklistTitle, checklistId]);

  function handleClose() {
    if (loading) return;
    if (typeof onClose === 'function') onClose();
  }

  async function handleConfirm() {
    setTouched(true);
    if (!isValid) return;
    if (typeof onConfirm === 'function') {
      await onConfirm(trimmed);
    }
  }

  return (
    <Modal
      size="lg"
      backdrop="static"
      show={open}
      handleClose={handleClose}
      heading={
        <div style={styles.headingSubtitle}> Cancelamento: {displayTitle}</div>
      }
      body={
        <>
          <Text type="regular" color="gray" style={styles.helperText}>
            Tem certeza que deseja encerrar este checklist? Não será possivel reverter a situação.
          </Text>
          <div style={styles.label}>
            <Text type="label" color="dark">
              Observações
            </Text>
          </div>
          <TextArea
            value={reason}
            onChange={(e) => setReason(e?.target?.value ?? '')}
            onBlur={() => setTouched(true)}
            minHeight="110px"
            placeholder="Descreva o motivo do cancelamento..."
            disabled={loading}
            containerStyle={{ width: '100%' }}
            style={{ width: '100%' }}
          />
          {!!error && (
            <div style={styles.error}>
              <Text color="danger" weight="700">
                {error}
              </Text>
            </div>
          )}
        </>
      }
      footer={
        <>
          <Button
            variant="secondary"
            onClick={handleClose}
            disabled={loading}
            style={styles.footerBtnSecondary}
          >
            Voltar
          </Button>
          <Button
            variant="primary"
            onClick={handleConfirm}
            disabled={loading || !isValid}
            style={styles.footerBtn}
          >
            Cancelar checklist
          </Button>
        </>
      }
    />
  );
}
